/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  CoinPaymaster,
  CoinPaymasterInterface,
} from "../../../contracts/samples/CoinPaymaster";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "accountFactory",
        type: "address",
      },
      {
        internalType: "contract IEntryPoint",
        name: "_entryPoint",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "unstakeDelaySec",
        type: "uint32",
      },
    ],
    name: "addStake",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "entryPoint",
    outputs: [
      {
        internalType: "contract IEntryPoint",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getDeposit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum IPaymaster.PostOpMode",
        name: "mode",
        type: "uint8",
      },
      {
        internalType: "bytes",
        name: "context",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "actualGasCost",
        type: "uint256",
      },
    ],
    name: "postOp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "theFactory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unlockStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "initCode",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "callGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "verificationGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preVerificationGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "paymasterAndData",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct UserOperation",
        name: "userOp",
        type: "tuple",
      },
      {
        internalType: "bytes32",
        name: "userOpHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "maxCost",
        type: "uint256",
      },
    ],
    name: "validatePaymasterUserOp",
    outputs: [
      {
        internalType: "bytes",
        name: "context",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "validationData",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "withdrawAddress",
        type: "address",
      },
    ],
    name: "withdrawStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "withdrawAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "0x60c060405234801561001057600080fd5b50604051610eeb380380610eeb83398101604081905261002f916100bc565b8061003933610054565b6001600160a01b039081166080529190911660a052506100f6565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b6001600160a01b03811681146100b957600080fd5b50565b600080604083850312156100cf57600080fd5b82516100da816100a4565b60208401519092506100eb816100a4565b809150509250929050565b60805160a051610d986101536000396000818161018401526109c30152600081816101d8015281816102e4015281816103ae0152818161041e015281816104e50152818161057501528181610628015261086f0152610d986000f3fe6080604052600436106100d25760003560e01c8063b0d691fe1161007f578063c399ec8811610059578063c399ec881461022f578063d0e30db014610252578063f2fde38b1461025a578063f465c77e1461027a57600080fd5b8063b0d691fe146101c6578063bb9fe6bf146101fa578063c23a5cea1461020f57600080fd5b80638da5cb5b116100b05780638da5cb5b146101215780639f5ca22114610172578063a9a23409146101a657600080fd5b80630396cb60146100d7578063205c2878146100ec578063715018a61461010c575b600080fd5b6100ea6100e5366004610a75565b6102a8565b005b3480156100f857600080fd5b506100ea610107366004610ac4565b61035a565b34801561011857600080fd5b506100ea6103f2565b34801561012d57600080fd5b5060005473ffffffffffffffffffffffffffffffffffffffff165b60405173ffffffffffffffffffffffffffffffffffffffff90911681526020015b60405180910390f35b34801561017e57600080fd5b506101487f000000000000000000000000000000000000000000000000000000000000000081565b3480156101b257600080fd5b506100ea6101c1366004610af0565b610406565b3480156101d257600080fd5b506101487f000000000000000000000000000000000000000000000000000000000000000081565b34801561020657600080fd5b506100ea610414565b34801561021b57600080fd5b506100ea61022a366004610b7f565b610498565b34801561023b57600080fd5b50610244610544565b604051908152602001610169565b6100ea6105fa565b34801561026657600080fd5b506100ea610275366004610b7f565b610682565b34801561028657600080fd5b5061029a610295366004610b9c565b61073e565b604051610169929190610bf0565b6102b0610761565b6040517f0396cb6000000000000000000000000000000000000000000000000000000000815263ffffffff821660048201527f000000000000000000000000000000000000000000000000000000000000000073ffffffffffffffffffffffffffffffffffffffff1690630396cb609034906024016000604051808303818588803b15801561033e57600080fd5b505af1158015610352573d6000803e3d6000fd5b505050505050565b610362610761565b6040517f205c287800000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff8381166004830152602482018390527f0000000000000000000000000000000000000000000000000000000000000000169063205c287890604401600060405180830381600087803b15801561033e57600080fd5b6103fa610761565b61040460006107e2565b565b61040e610857565b50505050565b61041c610761565b7f000000000000000000000000000000000000000000000000000000000000000073ffffffffffffffffffffffffffffffffffffffff1663bb9fe6bf6040518163ffffffff1660e01b8152600401600060405180830381600087803b15801561048457600080fd5b505af115801561040e573d6000803e3d6000fd5b6104a0610761565b6040517fc23a5cea00000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff82811660048301527f0000000000000000000000000000000000000000000000000000000000000000169063c23a5cea90602401600060405180830381600087803b15801561052957600080fd5b505af115801561053d573d6000803e3d6000fd5b5050505050565b6040517f70a082310000000000000000000000000000000000000000000000000000000081523060048201526000907f000000000000000000000000000000000000000000000000000000000000000073ffffffffffffffffffffffffffffffffffffffff16906370a0823190602401602060405180830381865afa1580156105d1573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906105f59190610c6b565b905090565b6040517fb760faf90000000000000000000000000000000000000000000000000000000081523060048201527f000000000000000000000000000000000000000000000000000000000000000073ffffffffffffffffffffffffffffffffffffffff169063b760faf99034906024016000604051808303818588803b15801561052957600080fd5b61068a610761565b73ffffffffffffffffffffffffffffffffffffffff8116610732576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201527f646472657373000000000000000000000000000000000000000000000000000060648201526084015b60405180910390fd5b61073b816107e2565b50565b6060600061074a610857565b6107558585856108f6565b91509150935093915050565b60005473ffffffffffffffffffffffffffffffffffffffff163314610404576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610729565b6000805473ffffffffffffffffffffffffffffffffffffffff8381167fffffffffffffffffffffffff0000000000000000000000000000000000000000831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b3373ffffffffffffffffffffffffffffffffffffffff7f00000000000000000000000000000000000000000000000000000000000000001614610404576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601560248201527f53656e646572206e6f7420456e747279506f696e7400000000000000000000006044820152606401610729565b606060006109076040860186610c84565b1590506109175761091785610980565b6109246020860186610b7f565b6040805173ffffffffffffffffffffffffffffffffffffffff909216602083015201604080517fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe081840301815291905295600095509350505050565b600061098f6040830183610c84565b61099e91601491600091610cf0565b6109a791610d1a565b60601c905073ffffffffffffffffffffffffffffffffffffffff7f0000000000000000000000000000000000000000000000000000000000000000168114610a71576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602560248201527f546f6b656e5061796d61737465723a2077726f6e67206163636f756e7420666160448201527f63746f72790000000000000000000000000000000000000000000000000000006064820152608401610729565b5050565b600060208284031215610a8757600080fd5b813563ffffffff81168114610a9b57600080fd5b9392505050565b73ffffffffffffffffffffffffffffffffffffffff8116811461073b57600080fd5b60008060408385031215610ad757600080fd5b8235610ae281610aa2565b946020939093013593505050565b60008060008060608587031215610b0657600080fd5b843560038110610b1557600080fd5b9350602085013567ffffffffffffffff80821115610b3257600080fd5b818701915087601f830112610b4657600080fd5b813581811115610b5557600080fd5b886020828501011115610b6757600080fd5b95986020929092019750949560400135945092505050565b600060208284031215610b9157600080fd5b8135610a9b81610aa2565b600080600060608486031215610bb157600080fd5b833567ffffffffffffffff811115610bc857600080fd5b84016101608187031215610bdb57600080fd5b95602085013595506040909401359392505050565b604081526000835180604084015260005b81811015610c1e5760208187018101516060868401015201610c01565b81811115610c30576000606083860101525b50602083019390935250601f919091017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe01601606001919050565b600060208284031215610c7d57600080fd5b5051919050565b60008083357fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe1843603018112610cb957600080fd5b83018035915067ffffffffffffffff821115610cd457600080fd5b602001915036819003821315610ce957600080fd5b9250929050565b60008085851115610d0057600080fd5b83861115610d0d57600080fd5b5050820193919092039150565b7fffffffffffffffffffffffffffffffffffffffff0000000000000000000000008135818116916014851015610d5a5780818660140360031b1b83161692505b50509291505056fea2646970667358221220a33b0ee8e081d4f6d7492aaad51d105aaec489977b720cecd77aacc0520406a464736f6c634300080f0033";

type CoinPaymasterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CoinPaymasterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CoinPaymaster__factory extends ContractFactory {
  constructor(...args: CoinPaymasterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    accountFactory: PromiseOrValue<string>,
    _entryPoint: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<CoinPaymaster> {
    return super.deploy(
      accountFactory,
      _entryPoint,
      overrides || {}
    ) as Promise<CoinPaymaster>;
  }
  override getDeployTransaction(
    accountFactory: PromiseOrValue<string>,
    _entryPoint: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      accountFactory,
      _entryPoint,
      overrides || {}
    );
  }
  override attach(address: string): CoinPaymaster {
    return super.attach(address) as CoinPaymaster;
  }
  override connect(signer: Signer): CoinPaymaster__factory {
    return super.connect(signer) as CoinPaymaster__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CoinPaymasterInterface {
    return new utils.Interface(_abi) as CoinPaymasterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CoinPaymaster {
    return new Contract(address, _abi, signerOrProvider) as CoinPaymaster;
  }
}
